(function () {
  function formatWeightKg(value) {
    if (!isFinite(value)) {
      return '';
    }

    return Number.isInteger(value) ? value.toFixed(0) : value.toFixed(1);
  }

  function formatGrams(value) {
    return Math.round(value) + 'g';
  }

  function createAgeOption(doc, ageBand) {
    const option = doc.createElement('option');
    option.value = ageBand.key;
    option.textContent = ageBand.label;
    option.dataset.min = String(ageBand.min);
    option.dataset.max = String(ageBand.max);
    return option;
  }

  function initCalculator(root) {
    const sizeSelect = root.querySelector('[data-puppy-size]');
    const ageSelect = root.querySelector('[data-puppy-age]');
    const weightInput = root.querySelector('[data-puppy-weight]');
    const calculateButton = root.querySelector('[data-puppy-calculate]');
    const results = root.querySelector('[data-puppy-results]');
    const message = root.querySelector('[data-puppy-message]');
    const sizeNote = root.querySelector('[data-puppy-size-note]');
    const dailyRange = root.querySelector('[data-puppy-daily-range]');
    const dailyMid = root.querySelector('[data-puppy-daily-mid]');
    const monthly250 = root.querySelector('[data-puppy-monthly-250]');
    const monthly500 = root.querySelector('[data-puppy-monthly-500]');
    const summary = root.querySelector('[data-puppy-summary]');

    if (!sizeSelect || !ageSelect || !weightInput || !calculateButton || !results || !message) {
      return;
    }

    function setText(node, value) {
      if (node) {
        node.textContent = value;
      }
    }

    const guidance = {
      toy: {
        label: 'Toy breed puppies',
        note: 'Adult weight under 5kg.',
        ages: [
          { key: '2-3', label: '2 - 3 months', min: 7, max: 8 },
          { key: '3-4', label: '3 - 4 months', min: 5, max: 7 },
          { key: '4-5', label: '4 - 5 months', min: 4, max: 6 },
          { key: '5-6', label: '5 - 6 months', min: 4, max: 5 },
          { key: '6-7', label: '6 - 7 months', min: 3, max: 3.5 },
          { key: '8-plus', label: '8 months onwards', min: 2.5, max: 3 },
        ],
      },
      small: {
        label: 'Small breed puppies',
        note: 'Adult weight 6 - 10kg.',
        ages: [
          { key: '2-3', label: '2 - 3 months', min: 7, max: 8 },
          { key: '3-4', label: '3 - 4 months', min: 6, max: 7 },
          { key: '4-5', label: '4 - 5 months', min: 5, max: 6 },
          { key: '5-6', label: '5 - 6 months', min: 4, max: 5 },
          { key: '6-9', label: '6 - 9 months', min: 3, max: 4 },
          { key: '9-10-plus', label: '9 - 10 months onwards', min: 2, max: 3 },
        ],
      },
      medium: {
        label: 'Medium and large breed puppies',
        note: 'Adult weight 10kg and above.',
        ages: [
          { key: '2-3', label: '2 - 3 months', min: 8, max: 8 },
          { key: '3-4', label: '3 - 4 months', min: 6, max: 7 },
          { key: '4-6', label: '4 - 6 months', min: 5, max: 6 },
          { key: '6-9', label: '6 - 9 months', min: 3, max: 4 },
          { key: '9-12', label: '9 - 12 months', min: 2, max: 3 },
          { key: '12-plus', label: '12 months onwards', min: 2, max: 2 },
        ],
      },
      giant: {
        label: 'Giant breeds',
        note: 'Adult weight 50kg and above.',
        ages: [
          { key: '2-4', label: '2 - 4 months', min: 8, max: 8 },
          { key: '4-6', label: '4 - 6 months', min: 5, max: 7 },
          { key: '6-9', label: '6 - 9 months', min: 4, max: 5 },
          { key: '9-12', label: '9 - 12 months', min: 2.5, max: 3 },
          { key: '12-18', label: '12 - 18 months', min: 2, max: 2.5 },
          { key: '18-plus', label: '18 months onwards', min: 2, max: 2 },
        ],
      },
    };

    function clearResults() {
      message.textContent = '';
      results.hidden = true;
    }

    function populateAgeOptions(sizeKey) {
      const sizeBand = guidance[sizeKey];
      ageSelect.innerHTML = '';

      if (!sizeBand) {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Choose a size band first';
        ageSelect.appendChild(placeholder);
        ageSelect.disabled = true;
        setText(sizeNote, '');
        return;
      }

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select an age band';
      ageSelect.appendChild(placeholder);

      sizeBand.ages.forEach(function (ageBand) {
        ageSelect.appendChild(createAgeOption(document, ageBand));
      });

      ageSelect.disabled = false;
      setText(sizeNote, sizeBand.label + ' - ' + sizeBand.note);
      ageSelect.value = '';
    }

    function calculate() {
      const sizeKey = sizeSelect.value;
      const ageOption = ageSelect.options[ageSelect.selectedIndex];
      const weight = parseFloat(weightInput.value);

      if (!guidance[sizeKey] || !ageOption || !ageOption.value || !isFinite(weight) || weight <= 0) {
        message.textContent = 'Please choose a size band, age band, and current weight.';
        results.hidden = true;
        return;
      }

      const minPct = parseFloat(ageOption.dataset.min);
      const maxPct = parseFloat(ageOption.dataset.max);
      const midpointPct = (minPct + maxPct) / 2;

      const dailyMin = (weight * 1000 * minPct) / 100;
      const dailyMax = (weight * 1000 * maxPct) / 100;
      const dailyMid = (weight * 1000 * midpointPct) / 100;
      const monthlyMin = dailyMin * 30;
      const monthlyMax = dailyMax * 30;

      dailyRange.textContent = formatGrams(dailyMin) + ' - ' + formatGrams(dailyMax);
      dailyMid.textContent = formatGrams(dailyMid);
      monthly250.textContent = Math.ceil(monthlyMin / 250) + ' - ' + Math.ceil(monthlyMax / 250);
      monthly500.textContent = Math.ceil(monthlyMin / 500) + ' - ' + Math.ceil(monthlyMax / 500);
      summary.textContent =
        guidance[sizeKey].label +
        ', ' +
        ageOption.textContent +
        ', ' +
        formatWeightKg(weight) +
        'kg bodyweight.';

      message.textContent = '';
      results.hidden = false;
    }

    sizeSelect.addEventListener('change', function () {
      populateAgeOptions(sizeSelect.value);
      clearResults();
    });

    ageSelect.addEventListener('change', clearResults);
    weightInput.addEventListener('input', clearResults);
    calculateButton.addEventListener('click', calculate);

    populateAgeOptions(sizeSelect.value);
    clearResults();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-puppy-calculator]').forEach(initCalculator);
  });
})();
